import { render } from "./InfraSummary.vue?vue&type=template&id=a9187dd0&scoped=true"
import script from "./InfraSummary.vue?vue&type=script&lang=js"
export * from "./InfraSummary.vue?vue&type=script&lang=js"

import "./InfraSummary.vue?vue&type=style&index=0&id=a9187dd0&lang=scss&scoped=true"

import exportComponent from "/opt/novus-cloud-ui/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a9187dd0"]])

export default __exports__